var map = {
	"./absence.svg": 607,
	"./assigment-interview.svg": 608,
	"./books.svg": 609,
	"./calendar.svg": 610,
	"./certificateRequest.svg": 611,
	"./course-catalog.svg": 612,
	"./course-schedule.svg": 613,
	"./courses.svg": 614,
	"./dmc-my.svg": 615,
	"./employee-recognition.svg": 616,
	"./help.svg": 617,
	"./job-offers.svg": 618,
	"./kpi.svg": 619,
	"./learning-history.svg": 620,
	"./library.svg": 621,
	"./main.svg": 622,
	"./my-app-vacation.svg": 623,
	"./my-books.svg": 624,
	"./my-courses.svg": 625,
	"./my-education.svg": 626,
	"./my-kpi.svg": 627,
	"./my-profile.svg": 628,
	"./my-rating.svg": 629,
	"./my-team.svg": 630,
	"./rating-students.svg": 631,
	"./schedule-offsets.svg": 632,
	"./team-kpi.svg": 633,
	"./team-rating.svg": 634,
	"./trainingPlan.svg": 635,
	"./vacation.svg": 636
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1073;